<div>
    <page-main></page-main>
</div>
